module.exports = __webpack_public_path__ + "img/qr_code_badge_black_hr.0cda4f0d.svg";